import LZString from 'lz-string';

export const setLocalStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getLocalStorage = (key: string) => {
  if (key) {
    const actionOfUser = localStorage.getItem(key);
    if (actionOfUser) {
      return JSON.parse(actionOfUser);
    }
  }
  return null;
};

export const clearLocalStorageByKey = (key: string) => {
  if (key) localStorage.removeItem(key);
};

//! Compare if two arrays have the same elements regardless of their order
export const compareTwoArrayOfObjects: any = (arr1: any, arr2: any) => {
  //! If they point to the same instance of the array
  if (arr1 === arr2) return true;

  //! If they point to the same instance of date
  if (arr1 instanceof Date && arr2 instanceof Date)
    return arr1.getTime() === arr2.getTime();

  //! If one of them are not null or their type is not an object
  if (!arr1 || !arr2 || (typeof arr1 !== 'object' && typeof arr2 !== 'object'))
    return arr1 === arr2;

  //! If they are not the same type of objects
  if (arr1.prototype !== arr2.prototype) return false;

  //! Check if both of the objects have the same number of keys
  const keysArr1 = Object.keys(arr1);
  const keysArr2 = Object.keys(arr2);
  if (keysArr1.length !== keysArr2.length) return false;

  //! Check recursively for every key in both
  return keysArr1.every((k) => compareTwoArrayOfObjects(arr1[k], arr2[k]));
};

export const restoreState = (
  keyState: string,
  columnApi: any,
  currentUrl: string,
  isLoggedIn: boolean,
  searchRequest: any,
  keyTabState: string,
  tabId: string,
  setIsDisplayOptionApplied: (isDisplayOptionApplied: boolean) => void,
  setIsMarketplaceApplied: (isMarketplaceApplied: boolean) => void,
  setIsExcludeTariffApplied: (isExcludeTariffApplied: boolean) => void,
  setIsStockingApplied: (isStockingApplied: boolean) => void,
  setIsUsingLocalStoraged: (isUsingLocalStoraged: boolean) => void,
  updateUrl: (suffixUrl: string) => void,
  setSearchRequest: (searchRequest: any) => void,
  externalFilterChanged: (checkboxName: string, isChecked: boolean) => void
) => {
  // ! if user search part not page share
  if (columnApi) {
    let updateRequest = { ...searchRequest };
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if(!url.href.includes('/short/') && !params.has('listId') && !params.has('uniqueId')) {
      // ! available when user logged in
      if (getLocalStorage(keyState) && isLoggedIn) {
        const filterData = getLocalStorage(keyState);
        const tabData = getLocalStorage(keyTabState);
        const urlParamsStateAtLocalStorage = new URLSearchParams(
          new URL('', currentUrl).search
        );
        const decodedParams = new URLSearchParams(
          '?' +
            LZString.decompressFromEncodedURIComponent(
              urlParamsStateAtLocalStorage.get('s')!
            )
        );

        // ! apply row order and sort for column
        if (tabData?.colStates?.length > 0) {
          columnApi.applyColumnState({
            state: tabData?.colStates,
            applyOrder: true
          });
          decodedParams.set('colStages', JSON.stringify(tabData?.colStates));
          decodedParams.set('isOrderByColumn', 'true');
        } else {
          decodedParams.delete('colStages');
          decodedParams.delete('isOrderByColumn');
        }

        // ! checkbox active parts
        if (filterData.isActiveChecked) {
          setIsDisplayOptionApplied(true);
          decodedParams.set('active', 'true');
          externalFilterChanged("activePartFilter", true);
          updateRequest = {
            ...updateRequest,
            productStatusFilter: [{id: "0"}]
            
          };
        } else {
          setIsDisplayOptionApplied(false);
          decodedParams.set('active', 'false');
          externalFilterChanged("activePartFilter", false);
          delete updateRequest.productStatusFilter;
        }

        // ! checkbox exclude marketplace
        if (filterData.isMarketplaceChecked) {
          setIsMarketplaceApplied(true);
          decodedParams.set('marketplace', 'true');
          externalFilterChanged("marketplaceFilter", true);
          updateRequest = {
            ...updateRequest,
            marketPlaceFilter: 'ExcludeMarketPlace'
          };
        } else {
          setIsMarketplaceApplied(false);
          decodedParams.set('marketplace', 'false');
          externalFilterChanged("marketplaceFilter", false);
          updateRequest = { ...updateRequest, marketPlaceFilter: undefined };
          delete updateRequest.marketPlaceFilter;
        }

        // ! checkbox exclude tariff
        if (filterData.isExcludeTariffChecked && tabId === "tabCompareAtt") {
          setIsExcludeTariffApplied(true);
          decodedParams.set('excludeTariffFilter', 'true');
          externalFilterChanged("excludeTariffFilter", true);
          updateRequest = {
            ...updateRequest,
            excludeFilter: ["ExcludeTariff"]
          };
        } else {
          setIsExcludeTariffApplied(false);
          decodedParams.set('excludeTariffFilter', 'false');
          externalFilterChanged("excludeTariffFilter", false);
          updateRequest = { ...updateRequest, excludeFilter: undefined };
          delete updateRequest.excludeFilter;
        }

        // ! checkbox in stock
        if (filterData.isStockingChecked) {
          setIsStockingApplied(true);
          decodedParams.set('stocking', 'true');
          externalFilterChanged("inStockingFilter", true);
          let searchOptions: string[] = updateRequest.searchOptions && updateRequest.searchOptions.includes('InStock')
            ? [...updateRequest.searchOptions]
            : ['InStock'];
          updateRequest = { ...updateRequest, searchOptions: [...searchOptions] };
        } else {
          setIsStockingApplied(false);
          decodedParams.set('stocking', 'false');
          externalFilterChanged("inStockingFilter", false);
          updateRequest = { ...updateRequest, searchOptions: undefined };
          delete updateRequest.searchOptions;
        }

        if(tabId === "tabReverseLookup"){
          setSearchRequest(updateRequest);
        }

        // ! sort order
        if (tabData?.sortOrder?.colId && tabData?.sortOrder?.sort) {
          columnApi.applyColumnState({
            state: [
              {
                colId: tabData?.sortOrder?.colId,
                sort: tabData?.sortOrder?.sort
              }
            ]
          });
          decodedParams.set('colId', tabData?.sortOrder?.colId);
          decodedParams.set('sort', tabData?.sortOrder?.sort);
        } else {
          columnApi.applyColumnState({
            defaultState: { sort: null }
          });
          decodedParams.delete('colId');
          decodedParams.delete('sort');
        }
        
        updateUrl(
          `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
        );
      }
    } else {
      // ! at page share
      let urlParamsColumnStages = new URLSearchParams(
        new URL('', currentUrl).search
      );
      const decodedParams = new URLSearchParams(
        '?' +
          LZString.decompressFromEncodedURIComponent(
            urlParamsColumnStages.get('s')!
          )
      );

      const colStages = decodedParams.get('colStages');
      if (colStages) {
        const colStates = JSON.parse(colStages);

        // ! apply row order and sort for column
        columnApi.applyColumnState({
          state: colStates,
          applyOrder: true
        });
      }
    }
    setIsUsingLocalStoraged(false);
  }
};

export const createOrUpdateKeyState = (
  keyParent: string,
  keyChildren: string,
  param: any
) => {
  if (getLocalStorage(keyParent)) {
    const data = getLocalStorage(keyParent);
    const userActionData = { ...data, [keyChildren]: param };

    setLocalStorage(keyParent, userActionData);
  } else {
    setLocalStorage(keyParent, { [keyChildren]: param });
  }
};

// ! Delete filter order param
export const deleteParamColumnOrderToShare = (
  currentUrl: string,
  updateUrl: (suffixUrl: string) => void
) => {
  let urlParamsRemovedFilter = new URLSearchParams(
    new URL('', currentUrl).search
  );
  const decodedParams = new URLSearchParams(
    '?' +
      LZString.decompressFromEncodedURIComponent(
        urlParamsRemovedFilter.get('s')!
      )
  );
  decodedParams.delete('colStages');
  decodedParams.delete('isOrderByColumn');
  updateUrl(
    `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
  );
};
